const langItArca = {
	cc_components_cc_order_summary_order_notes_label: 'Note per il punto vendita/prodotti non trovati',
	cc_components_cc_order_summary_order_notes_placeholder: 'Inserisci qui eventuali note per il punto vendita o segnalazioni di prodotti non trovati',
	cc_components_cc_order_summary_order_info_total: "subtotale ordine",
	cc_components_cc_order_summary_order_info_iva_not_included: "(netto iva)",
	cc_components_cc_order_summary_order_empty_cart_button: "Svuota carrello",
	cc_components_cc_order_summary_order_info_send_order: "Invia ordine"
};
export default langItArca;
